import { motion } from "framer-motion";

const easing = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: easing }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

// Line-by-line masked text reveal
export const MaskedLines = ({ lines, className = "", lineClass = "", delay = 0, trigger = "load" }) => {
  const animateProps =
    trigger === "load"
      ? { animate: { y: "0%" } }
      : { whileInView: { y: "0%" }, viewport: { once: true, margin: "-80px" } };
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="line-mask">
          <motion.span
            className={`block ${lineClass}`}
            initial={{ y: "110%" }}
            {...animateProps}
            transition={{ duration: 1, delay: delay + i * 0.12, ease: easing }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};
